import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { typeLabel } from '../../utils/categoricalColors';
import { formatInt } from '../../utils/numberFormat';
import { formatDate } from '../../utils/dateUtils';

/**
 * Ultimi documenti elaborati. Il codice apre la scheda del documento: la rotta naviga per **id**
 * (`/codex/:codexId`), non per codice, che non è univoco.
 *
 * I documenti per cui non è stata conteggiata alcuna pagina non mostrano «0» ma «non conteggiato»:
 * uno zero accanto a un documento elaborato è una segnalazione garantita.
 */
const UsageDocumentsTable = ({ page, onPageChange, onSizeChange }) => {
  const rows = page?.content ?? [];

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Documento</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell align="right">Pagine</TableCell>
            <TableCell>Elaborato il</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.codexId} hover>
              <TableCell>
                <Link component={RouterLink} to={`/codex/${row.codexId}`} underline="hover">
                  {row.codexCode ?? row.codexId}
                </Link>
              </TableCell>
              <TableCell>{typeLabel(row)}</TableCell>
              <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                {row.pagesCounted ? (
                  formatInt(row.pages)
                ) : (
                  <Tooltip title="Il formato dei file di questo documento non è fra quelli per cui vengono contate le pagine">
                    <Typography variant="body2" color="text.secondary" component="span">
                      non conteggiato
                    </Typography>
                  </Tooltip>
                )}
              </TableCell>
              <TableCell>{formatDate(row.lastProcessedAt)}</TableCell>
            </TableRow>
          ))}
          {!rows.length && (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography color="text.secondary">Nessun documento elaborato nel periodo selezionato</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={page?.totalElements ?? 0}
        page={page?.number ?? 0}
        rowsPerPage={page?.size ?? 10}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={(event, nuovaPagina) => onPageChange(nuovaPagina)}
        onRowsPerPageChange={(event) => onSizeChange(parseInt(event.target.value, 10))}
        labelRowsPerPage="Righe per pagina"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} di ${count}`}
      />
    </>
  );
};

export default UsageDocumentsTable;
